export default {
  address: 'Address *',
  'create-account-247-support': '24/7 Support',
  'create-account-secure': '100% Secure',
  'create-account-fast': 'Fast & Easy Withdrawals',
  'create-account-gambling-commission': 'Malta Gaming Authority',
  'create-account-gambling-commission-ca-ont': 'iGaming Ontario Authority',

  'create-account-promotion-amount': '##AMOUNT##',
  'create-account-promotion-type': 'Welcome Bonus',
  'create-account-promotion-description': 'Up to ##UPTO_AMOUNT## on your first deposit',
  'create-account-promotion-spins-bonus': '+ ##SPINS_AMOUNT## Free Spins',
  'create-account-promotion-spins-bonus-ca-ont': '+ ##SPINS_AMOUNT## Bonus Spins',
  'create-account-promotion-spins-bonus-gb': '+ ##SPINS_AMOUNT## Bonus Spins',
  'create-account-wo-terms': '%welcomePromoterms%',

  'create-account-promotion-terms-row':
    '<a href="/player-protection">18+</a>. <a href="/promotions?scrollto=welcome_promoterms" class="ui-link">Terms apply.</a> Please gamble responsibly. <a href="http://www.gamblingtherapy.org" target="_blank">www.Gamblingtherapy.org</a>',

  'create-account-promotion-terms-gb':
    '<a href="/playerprotection">18+.</a> New Players Only. 1 bonus offer per player. Min. deposit %minDeposit%. Max. bonus bet is %maxBonusBet%. Bonus spins on selected games only and must be used within 72 hours. Winnings from Bonus spins credited as bonus funds and capped at %maxCap%. Bonus funds expire in 30 days, unused bonus funds will be removed. Welcome Offer is %firstBonus% match up to %firstUpTo% + %firstSpins% bonus spins on your 1st deposit, %secondBonus% match up to %secondUpTo% + %secondSpins% bonus spins on your 2nd deposit, and %thirdBonus% match up to %thirdUpTo% + %thirdSpins% bonus spins on your 3rd deposit. Bonus funds are separate to Cash funds, and are subject to 35x wagering the total bonus & cash. Only bonus funds count towards wagering contribution. <a href="/promotions?scrollto=welcome_promoterms" class="ui-link">Terms apply.</a> Please gamble responsibly. <a href="http://www.begambleaware.org/" target="_blank">BeGambleAware.org</a>',

  'create-account-promotion-terms-latam':
    '<a href="/player-protection">18+</a>. <a href="/promotions?scrollto=welcome_promoterms" class="ui-link">Terms apply.</a> Please gamble responsibly. <a href="http://www.gamblingtherapy.org" target="_blank">www.Gamblingtherapy.org</a>',

  //Sign in btn text
  'create-account-promotion-sign-in': 'Already have an account?',
  'create-account-close': 'close',

  // step 1
  'personal-details-title': 'Sign up',
  'personal-details-supporting-text': 'Just 3 simple steps',

  // step 2
  'address-details-title': 'Nearly There!',
  'address-details-supporting-text': "You're flying through!",

  // step 3
  'account-details-title': '%firstname%',
  'account-details-supporting-text': 'This is the last step!',

  // helpandsupport_contactinfo_h2
  // gi_account_information

  'trustly-personal-details-create-account': 'Continue',

  'marketing-preferences-title': 'Communication Preferences',
  'marketing-preferences-description':
    'Ursa Casino offers its Player Community unique Daily Deals & Monthly Highlights such as match bonuses, bonus spins, free spins, cashback offers, tournaments, leaderboards, real life prizes, experiences and holidays. To hear about these, please select below:',
  'marketing-preferences-post-text': 'You can update your communication preferences at any time in your My Account section.',
  'marketing-preferences-label-cross-brand': 'I want to hear about exclusive offers from your casino network.',
  'marketing-preferences-label-brand-only': 'I want to hear about exclusive offers from your casino only.',
  'marketing-preferences-label-email': 'I want to hear about offers via <strong>email</strong>',
  'marketing-preferences-label-sms': 'I want to hear about offers via <strong>sms</strong>',
  'marketing-preferences-label-phone-call': 'I want to hear about offers via <strong>phone call</strong>',
  'marketing-preferences-label-post': 'I want to hear about offers via <strong>post</strong>',

  'marketing-preferences-unified-description':
    '<strong>Don\'t miss</strong> the latest promotions and exclusive offers from Ursa Casino and the brands managed by <a href="/brands" target="_blank">our network</a>. Choose how you\'d like to receive communication from us.',
  'marketing-preferences-unified-label-email': 'Email',
  'marketing-preferences-unified-label-sms': 'SMS',
  'marketing-preferences-unified-label-phone-call': 'Phone',
  'marketing-preferences-unified-label-phone-post': 'Post',
  'deposit-custom-footer':
    "<ul><li class='safe-support'>24/7 Support</li><li class='one-hundred-percent-secure'>100% Secure</li><li class='usp-fast'>Fast & Easy Withdrawals</li></ul>",
  'fast-signup-bank': 'Continue Fast Signup',
  'faster-signup': 'Faster signup',
  'trustly-header': 'A trusted, simplified and fast registration process via your bank using Trustly',
  'trustly-signup': 'Sign up with trustly',
  'trustly-uk-signup': 'Instant Deposit & Sign up',
  'trustly-uk-deposit-header': 'Pay & Play',
  'trustly-uk-deposit-subheader': 'Instantly register with a quick deposit from your bank account',
  'trustly-uk-register-header': 'Register your details',
  'trustly-uk-register-subheader': 'Provide your e-mail address, password and phone number',
  'trustly-uk-signup-marketing-preferences-introheader': 'Marketing Preferences',
  'trustly-uk-signup-marketing-preferences-pretext': 'Choose how to receive personalised offers from Ursa Casino',
  'trustly-uk-signup-marketing-preferences-generic-error': 'Please set your marketing preferences',
  'trustly-uk-signup-marketing-preferences-posttext':
    'You can update how we contact you at any time in the \'Marketing Preferences\' section of \'Settings\'. <br>For information about how we handle your data read our <a href="/privacy" target="_blank">Privacy and Cookie Notice</a>.',
  'trustly-uk-signup-marketing-preferences-cross':
    "Receive personalised offers by the same methods from other Casino's within the Ursa Casino group.",
  'trustly-uk-signup-marketing-preferences-none': 'None of the above',
  'or-signup-option': 'or',
  terms_and_conditions_ont:
    "<a href='/playerprotection'>19+</a>. <a href='/promoterms'>Terms Apply</a>. </a> <a href='http://ConnexOntario.ca/'>ConnexOntario.ca</a>",
  'marketing-preferences-pre-text': 'Choose how to receive bonuses, promotions, and updates.',
  'marketing-preferences-cross-marketing-description':
    'Receive promotional messages from our <a href="/brands" target="_blank">growing family</a> of online casinos.',
  'marketing-preferences-contact-options-email': 'Email',
  'marketing-preferences-contact-options-sms': 'SMS',
  'marketing-preferences-contact-options-phone': 'Phone',
  'marketing-preferences-label-email-ontario': 'Email',
  'marketing-preferences-label-sms-ontario': 'SMS',
  'marketing-preferences-label-phone-ontario': 'Phone',
  'marketing-preferences-label-post-ontario': 'Post',
  'personal-details-title-ontario': 'Sign Up',
  'personal-details-button-text-ontario': 'Continue',
  'display-ontario': 'Set Limits (Optional)',
  'hoverText-deposit-ontario':
    'Daily deposit limits are calculated as 24 hours, weekly deposit limits as 7 days and monthly deposit limits as 28 days and they are measured retrospectively for the period selected',
  'hoverText-losslimit-ontario':
    'Daily loss limits are calculated as 24 hours (i.e. 00:00 until 23:59 in a day), weekly loss limits as 7 days (i.e. Monday 00:00 until Sunday 23:59) and monthly as a calendar month (00:00 on the 1st day or the month until 23:59 on the last day of the month)',
  'personal-details-supporting-text-ontario': 'The fields with a * are mandatory',
  'first-name-ontario': 'First Name *',
  'middle-name-ontario': 'Middle Name',
  'last-name-ontario': 'Last Name *',
  'preferred-name-ontario': 'Alias',
  'gender-ontario': 'Gender *',
  'please-select-ontario': 'Please Select',
  'period-please-select-ontario': 'Add Limit',
  'value-please-select-ontario': 'Add Value',
  'occupation-please-select-ontario': 'Add Occupation',
  'select-gender': 'Select Gender',
  'gender-male-ontario': 'Male',
  'gender-female-ontario': 'Female',
  'gender-other-ontario': 'Rather not say',
  'birth-date-ontario': 'Birth Date *',
  'date-format-ontario': 'Day, Month, Year',
  'show-ontario': 'Show',
  'hide-ontario': 'Hide',
  'deposit-limit-ontario': 'Deposit Limits',
  'loss-limits-ontario': 'Loss Limits',
  'country-ontario': 'Country *',
  'state-ontario': 'State *',
  'daily-ontario': 'Daily',
  'weekly-ontario': 'Weekly',
  'monthly-ontario': 'Monthly',
  'no-limit-ontario': 'No Limit',
  'personal-identity-number-ontario': 'Identity Number',
  'personal-identity-number-help-text-ontario': '',
  'address-details-continue-ontario': 'Continue',
  'address-details-title-ontario': 'Hi %firstname%',
  'address-details-supporting-text-ontario': 'Contact Information<br>The fields with a * are mandatory',
  'email-ontario': 'Email *',
  'phone-ontario': 'Phone Number *',
  'address-ontario': 'Address *',
  'citizenship-ontario': 'Citizenship',
  'occupations-state-ontario': 'Employment Status *',
  'sow-status-label-1-ontario': 'Employed',
  'sow-status-label-2-ontario': 'Self Employed',
  'sow-status-label-3-ontario': 'Unemployed',
  'sow-status-label-4-ontario': 'Retired',
  'occupations-ontario': 'Occupation *',
  'company-ontario': 'Company',
  'company-address-ontario': 'Company Address',
  'company-city-ontario': 'Company City',
  'company-zip-ontario': 'Company ZIP',
  'company-province-ontario': 'Company Province',
  'company-phone-ontario': 'Company Phone',
  'sign-up-ontario': 'Sign up',
  'account-details-title-ontario': 'Almost There',
  'account-details-supporting-text-ontario': 'Contact Information<br>The fields with a * are mandatory',
  'username-ontario': 'Username *',
  'username-help-text-ontario': 'Use between 6-20 letters and numbers, all lowercase without any spaces.',
  'password-ontario': 'Password *',
  'password-help-text-ontario': 'Use at least 8 characters',
  'currency-ontario': 'Currency *',
  'mandatory-field-ontario': 'The fields with a * are mandatory',
  'postalCode-format-rules-ont':
    "<ul>Postal Code validation:<li>Format: A1A 1A1 </li><li>'A' means letter</li><li>'1' means number</li></ul>",
  'only-characters-format': 'No special characters and numbers are allowed',
  'characters-numbers-format': 'No special characters are allowed',
};
